module.exports = __webpack_public_path__ + "static/intro_stories-e23076148bebcb4ad257ca61663f943c.png";